<template>
  <main
    id="top"
    class="cc-home"
  >
    <HeroSlider :data="data" />
    <Boutiques :data="data" />
    <BonsPlans :data="data" />
    <Actualites :data="data" />
    <Services :data="data" />
    <Acces :data="data" />
    <PlanHoraires :data="data" />
  </main>
</template>

<script>
import HeroSlider from '@/views/home/01_HeroSlider.vue'
import Boutiques from '@/views/home/02_Boutiques.vue'
import BonsPlans from '@/views/home/03_BonsPlans.vue'
import Actualites from '@/views/home/04_Actualites.vue'
import Services from '@/views/home/05_Services.vue'
import Acces from '@/views/home/06_Acces.vue'
import PlanHoraires from '@/views/home/07_PlanHoraires.vue'

export default {
  name: 'HomeView',
  components: {
    HeroSlider,
    Boutiques,
    BonsPlans,
    Actualites,
    Services,
    Acces,
    PlanHoraires
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
